// import { SearchMagnifyingGlassIcon } from '@forwardflow/icons'
import { CloseIcon, SearchMagnifyingGlassIcon } from '@forwardflow/icons'
import {
   IStage,
   useOnboardingStoreV2,
} from '@forwardflow/store/onboardingStoreV2'
import { Grid, Select, TextInput } from '@forwardflow/ui-v2'
import { v4 as uuidv4 } from 'uuid'

export const StageInput = ({
   shouldShowRemove = true,
   shouldAddDescription = false,
   value = null,
   onChange,
   stageDisabled = false,
   onRemove,
   index,
}: {
   shouldShowRemove?: boolean
   shouldAddDescription?: boolean
   value?: IStage | null
   onChange?: (value: IStage | null) => void
   stageDisabled?: boolean
   onRemove?: (index: number) => void
   index?: number
}) => {
   const { stages, tags } = useOnboardingStoreV2()
   const stagesOptions = stages?.map((stage) => ({
      ...stage,
      label: stage?.name,
      value: stage?.id,
   }))

   const onStageChange = (selectedStage: string | null) => {
      const stage = stagesOptions?.find(
         (stage) => selectedStage === String(stage?.id)
      )
      onChange?.({
         id: stage?.id || '',
         name: stage?.name || '',
         type: stage?.type || 'stage',
         description: stage?.description || '',
      })
   }

   const onTagChange = (v: string) => {
      onChange?.({
         id: '',
         name: v,
         type: 'tag',
         description: '',
      })
   }

   const onDescriptionChange = (description: string) => {
      onChange?.({
         id: value?.id || '',
         name: value?.name || '',
         type: value?.type || 'stage',
         description,
      })
   }

   const onTypeChange = (type: 'stage' | 'tag') => {
      onChange?.({
         id: '',
         name: '',
         type,
         description: value?.description || '',
      })
   }

   const type = value?.type || 'stage'

   return (
      <Grid>
         <Grid.Col span={3}>
            <Select
               data={[
                  { label: 'Stage', value: 'stage' },
                  { label: 'Tag', value: 'tag' },
               ]}
               value={value?.type || 'stage'}
               label="Type"
               onChange={(value) => onTypeChange(value as 'stage' | 'tag')}
            />
         </Grid.Col>
         <Grid.Col
            span={
               shouldAddDescription
                  ? shouldShowRemove
                     ? 3.5
                     : 4
                  : shouldShowRemove
                  ? 8.5
                  : 9
            }
         >
            {type === 'tag' ? (
               <Select
                  key={`tag-select-${uuidv4()}`}
                  leftSection={<SearchMagnifyingGlassIcon width={16} />}
                  label="Select Tag"
                  searchable
                  data={
                     tags?.length > 0
                        ? tags
                        : value?.name
                        ? [{ label: value?.name, value: value?.name }]
                        : []
                  }
                  value={value?.name || ''}
                  onChange={(value) => onTagChange(value || '')}
                  placeholder="Search for tags"
                  clearable
               />
            ) : (
               <Select
                  key={`stage-select-${uuidv4()}`}
                  label="Select Stage"
                  searchable
                  disabled={stageDisabled}
                  data={
                     stagesOptions?.map((stage) => ({
                        ...stage,
                        label: stage?.name,
                        value: String(stage?.id || ''),
                     })) || []
                  }
                  leftSection={<SearchMagnifyingGlassIcon width={16} />}
                  value={String(value?.id || '')}
                  onChange={(value) => onStageChange(value)}
                  placeholder="Search for stages"
                  clearable
               />
            )}
         </Grid.Col>
         {shouldAddDescription && (
            <Grid.Col span={5}>
               <TextInput
                  value={value?.description || ''}
                  label="Describe Stage"
                  placeholder="Eg: Leads who's timeline is less than 3 months"
                  onChange={(e) => onDescriptionChange(e.target.value)}
               />
            </Grid.Col>
         )}
         {shouldShowRemove && (
            <Grid.Col span={0.5} className="flex items-end justify-center pb-5">
               <CloseIcon
                  width={18}
                  height={18}
                  className="cursor-pointer hover:text-purple-500/80"
                  onClick={() => onRemove?.(index || 0)}
               />
            </Grid.Col>
         )}
      </Grid>
   )
}
